
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.79 6.617v1.04H4.382c-.552 0-1.021-.03-1.406-.087a4.187 4.187 0 01-.993-.273 3.004 3.004 0 01-.789-.531 3.087 3.087 0 01-.593-.75 3.461 3.461 0 01-.329-.907 5.041 5.041 0 01-.109-1.078c0-.937.167-1.659.5-2.164C.997 1.357 1.443.971 2 .711 2.563.45 3.393.32 4.492.32H9.79v1.038H4.547c-.6 0-1.068.037-1.406.11a2.285 2.285 0 00-.868.351c-.234.162-.43.414-.586.758-.156.339-.234.794-.234 1.367 0 .495.052.91.156 1.243.105.328.271.604.5.828.23.218.521.375.875.468.36.089.85.133 1.47.133h5.335zM.163 10V8.96H9.79V10H.164z","fill":"currentColor"}})])
          )
        }
      }
    